class Branding {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.branding_no = data ? data.branding_no : ''
    this.sort_no = data ? data.sort_no : 0
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : true
    this.thumbnail = data ? data.thumbnail : null
    this.thumbnailUrl = data ? data.thumbnailUrl : null
    this.AI = data ? data.AI : null
    this.PSD = data ? data.PSD : null
    this.EPS = data ? data.EPS : null
    this.PNG = data ? data.PNG : null
    this.PDF = data ? data.PDF : null
    this.JPG = data ? data.JPG : null
    this.ALL = data ? data.ALL : null
    this.WORD_DOC = data ? data.WORD_DOC : null
    this.downloads = data ? data.downloads : -1
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('name', this.name)
    formData.append('branding_no', this.branding_no)
    formData.append('sort_no', this.sort_no)
    formData.append('is_enabled', this.is_enabled === true)
    formData.append('thumbnail', this.thumbnail)
    formData.append('AI', this.AI)
    formData.append('PSD', this.PSD)
    formData.append('EPS', this.EPS)
    formData.append('PNG', this.PNG)
    formData.append('PDF', this.PDF)
    formData.append('JPG', this.JPG)
    formData.append('ALL', this.ALL)
    formData.append('WORD_DOC', this.WORD_DOC)
    return formData
  }
}

export default Branding



// WEBPACK FOOTER //
// ./src/models/Branding.js